import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "App";

// Providers
import { MaterialUIControllerProvider } from "context";
import { AuthContextProvider } from "context/AuthContext";
import { AbilityProvider } from "context/AbilityContext";
import { I18nProvider } from "context/I18nContext";
import { GlobalSnackbarProvider } from "context/GlobalSnackbarContext";
import { EventStreamProvider } from "context/EventStreamContext";
import { NotificationProvider } from "context/NotificationContext";

/**
 * Provider nesting order:
 *  BrowserRouter
 *    MaterialUIControllerProvider  (UI state: sidenav, dark mode, etc.)
 *      AuthContextProvider         (Firebase auth, user data, roles)
 *        I18nProvider              (react-intl, locale switching)
 *          AbilityProvider         (CASL abilities, fetched after auth)
 *            GlobalSnackbarProvider (snackbar notifications)
 *              EventStreamProvider  (unified SSE connection)
 *                NotificationProvider (notifications via SSE)
 *                  App
 */
ReactDOM.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <AuthContextProvider>
        <I18nProvider>
          <AbilityProvider>
            <GlobalSnackbarProvider>
              <EventStreamProvider>
                <NotificationProvider>
                  <App />
                </NotificationProvider>
              </EventStreamProvider>
            </GlobalSnackbarProvider>
          </AbilityProvider>
        </I18nProvider>
      </AuthContextProvider>
    </MaterialUIControllerProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
